import bgImage from '../../../../img/login_bg.jpg'

const signInStyle = theme => ({
	background: {
		position: "relative",
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 15),

		backgroundImage: `url(${bgImage})`,
		backgroundSize: 'cover',
		backgroundRepeat: "no-repeat",
		backgroundPosition: "top center",
	},

	paper: {
		position: "absolute",
		width: "350px",

		// marginTop: theme.spacing(window.innerHeight * 0.025),
		marginTop: theme.spacing(window.innerHeight * 0.035),
		
		padding: theme.spacing(3),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},

	noticePaper: {
		position: "absolute",
		width: "350px",

		marginTop: theme.spacing(window.innerHeight * 0.005),

		padding: theme.spacing(3),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},

	noticefont: {
		color: "red"
	},


	form: {
		width: "100%",
		marginTop: theme.spacing(1)
	},

	submit: {
		margin: theme.spacing(3, 0, 2)
	},


	divider: {
		paddingTop: theme.spacing(2)
	},

	oidcSignInBtn: {
		margin: theme.spacing(1.5, 0, 2)
	},
})

export default signInStyle